import React from 'react'
import { GptAdProvider } from './GptAdProvider'

export const GptAdProviderContext = React.createContext<GptAdProvider | undefined>(undefined)
